
    <div class="mt-10">
      <mat-grid-list cols="16" rowHeight="45px" >
        <mat-grid-tile [colspan]="8">
          
      <span class="dot-status dot-limegreen">&nbsp;</span>
      {{ "EncounterListPage.arrived" | translate }} ({{ statusCounts.arrived }})
      <span class="dot-status dot-red">&nbsp;</span>
      {{ "EncounterListPage.cancelled" | translate }} ({{
        statusCounts.cancelled
      }}) <span class="dot-status dot-blue">&nbsp;</span
      >{{ "EncounterListPage.billed" | translate }}({{
        statusCounts.checkedIn
      }})<span class="dot-status dot-gold">&nbsp;</span>
    {{"EncounterListPage.consulted"| translate}} ({{
        statusCounts.Finished
      }})
      <span class="dot-status" style="background-color: #D8D8D8;">&nbsp;</span>
      {{ "adt.checkout" | translate }} ({{ statusCounts.checkout}})
      <span class="dot-status" style="background-color:#BF77F6 ;">&nbsp;</span>
      {{ "adt.ConvertToIP" | translate }} ({{ statusCounts.convertIP}})
</mat-grid-tile>
<mat-grid-tile [colspan]="2"></mat-grid-tile>
<mat-grid-tile [colspan]="2" style="margin-right: 0px;">
  <input type="checkbox" class="round-checkbox" (change)="openEncounterFilterList($event)">&nbsp;&nbsp;
<b>{{ "adt.OpenEncounters" | translate }}</b>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="4" style="margin-right: 0px; margin-left: 5px;" >
      
        <mat-form-field appearance="outline" style="margin-right: 0px;margin-left: 1 px;">
          <input
            matInput
            [(ngModel)]="BarCode"
            placeholder="{{ 'labPage.Barcode' | translate }}"
            (focusout)="applyFilter(BarCode)"
          />
        </mat-form-field>
        <mat-icon style="color: #389683" 
          matTooltip="Scan QR/Barcode"
          (click)="openBarcodeScanDialog()"
        >
          center_focus_weak
        </mat-icon>
 
      </mat-grid-tile>
      </mat-grid-list>
    </div>
    <mat-drawer-container class="example-container">
    <mat-drawer-content>
    <div class="encounter-container mt-10">
      <table
        mat-table
        [dataSource]="dataSource"
        class="mat-elevation-z8 table-encounter"
      >
        <ng-container matColumnDef="Serial">
          <th mat-header-cell *matHeaderCellDef>
            {{ "EncounterListPage.sno" | translate }}
          </th>
          <td
            mat-cell
            class="col-norwap"
            *matCellDef="let element; let index = index"
            
          >
            {{ index + 1 + pageSize * (pageIndex - 1) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="EncounterNumber">
          <th mat-header-cell *matHeaderCellDef class="custom-header">
            {{ "CommonAppoinment.visit" | translate }} No
          </th>
          <td mat-cell class="col-nowrap" *matCellDef="let element" class="no-padding">
            <div>
              <span class="encounter-number">{{ element.EncounterNumber }}</span><br>
              <span class="encounter-token" [ngClass]="{ 'has-background': element.VisitType }">{{ element.VisitType }}</span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="Gender/Age">
            <th mat-header-cell *matHeaderCellDef  class="custom-header">
              {{ "adt.genderAge" | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
               <!-- [ngClass]="{'vip-background': element.isVip}"> -->
              <div class="cell-content">
                <img src="./assets/images/{{ element.patientImage }}" alt="image" class="patient-image" />
                <div class="patient-details">
                  <strong class="Age-font">{{ element.PatientAge }}</strong>
                  <span>{{ element.age }}</span>
                </div>
              </div>
            </td>            
          </ng-container>

        <ng-container matColumnDef="EncounterToken">
          <th mat-header-cell *matHeaderCellDef  class="custom-header">
            Queue No
          </th>
          <td mat-cell class="col-norwap" *matCellDef="let element">
            <!-- [ngClass]="{'vip-background': element.isVip}"> -->
            {{ element.EncounterToken }}
          </td>
        </ng-container>

        <ng-container matColumnDef="glStatus">
          <th mat-header-cell *matHeaderCellDef  class="custom-header">
            {{ "adt.glStatus" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <span
              class="glstatus-box"
              [ngStyle]="{ 'background-color': element.glStatus.backgroundColor }"
            >
              {{ element.glStatus.text }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="MRN">
          <th mat-header-cell *matHeaderCellDef  class="custom-header">
            {{"AppointmentListPage.patient"| translate}}
          </th>
          <td mat-cell class="col-nowrap" *matCellDef="let element"> 
          <!-- [ngClass]="{
            'vip-background': element.isVip,
            'long-name': element.PatientName.length > 25
          }"
          > -->
          <div>
            <div class="name-div">
              <strong class="name-container">{{ element.PatientName }}</strong>
              <div  *ngIf="element.isVip">
                <img src="./assets/images/vip-icon.png" height="20px"/>
               </div>
              <div *ngIf="element.isNoteVisible">
                <img src="./assets/images/chat-alert.png" [matTooltip]="element.isNoteVisible" />
              </div>
              <br>
            </div>
            <span class="doctor-name">{{ element.MRN }}</span>
          </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="DepartmentName">
          <th mat-header-cell *matHeaderCellDef class="custom-header">
            {{"adt.Speciality" | translate}}
          </th>
          <td mat-cell class="col-nowrap" *matCellDef="let element">
          <!-- [ngClass]="{
            'vip-background': element.isVip,
            'doctor-long-name': element.DoctorName.length > 50
          }"> -->
            <div>
              <strong class="Age-font">{{ element.DepartmentName }}</strong><br>
              <div class="name-div">
              <span class="name-contain">{{ element.DoctorName }}</span>
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="DoctorName">
          <th mat-header-cell *matHeaderCellDef class="custom-header">
           {{"EncounterPage.locationToken" | translate}}
          </th>
          <td mat-cell  *matCellDef="let element">
            <!-- [ngClass]="{
              'vip-background': element.isVip
            }">  -->
            <span class="encounter-number">{{ element.Clinic }}</span><br>
            <span class="encounter-token">
              <!-- [ngClass]="{ 'has-background': element.EncounterToken }"> -->
              {{ element.EncounterToken }}</span>
        </td>
        </ng-container>

        <ng-container matColumnDef="VisitDate">
          <th mat-header-cell *matHeaderCellDef class="custom-header">
            {{ "billing.visitDetails" | translate }} 
          </th>
          <td mat-cell class="col-norwap" *matCellDef="let element">
            <strong  class="Age-font">{{ langaugeValue=='th'?element.VisitDate: (element.VisitDate | date : "dd/MM/yyyy hh:mm aa")  }}</strong><br>
            <span>{{ element.time  }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="AppointmentDate">
          <th mat-header-cell *matHeaderCellDef class="custom-header">
            {{"AppointmentListPage.appointmentdate" | translate}}
          </th>
          <td mat-cell class="col-norwap" *matCellDef="let element">
             <!-- [ngClass]="{'vip-background': element.isVip}"> -->
            <strong  class="Age-font">{{ element.AppointmentDate  }}</strong><br>
            <span>{{ element.reference}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="Address">
          <th mat-header-cell *matHeaderCellDef class="custom-header">
            {{ "EncounterListPage.address" | translate }}
          </th>
          <td mat-cell class="col-norwap" *matCellDef="let element" >
            {{ element.Address }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Diagnosis">
          <th mat-header-cell *matHeaderCellDef class="custom-header">
            {{ "EncounterListPage.diagnosis" | translate }}
          </th>
          <td mat-cell class="col-norwap" *matCellDef="let element" >
            {{ element.Diagnosis }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Advise">
          <th mat-header-cell *matHeaderCellDef>
            {{ "EncounterListPage.advise" | translate }}
          </th>
          <td mat-cell class="col-norwap" *matCellDef="let element" >
            {{ element.Advise }}
          </td>
        </ng-container>

        <ng-container matColumnDef="ReferenceDoctor">
          <th mat-header-cell *matHeaderCellDef>
            {{ "EncounterListPage.reference" | translate }}
          </th>
          <td mat-cell class="col-norwap" *matCellDef="let element" >
            {{ element.ReferenceDoctor }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Clinic">
          <th mat-header-cell *matHeaderCellDef>
            {{ "EncounterListPage.clinic" | translate }}
          </th>
          <td mat-cell class="col-norwap" *matCellDef="let element" >
            {{ element.Clinic }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Triage">
          <th mat-header-cell *matHeaderCellDef>
            {{ "EncounterListPage.triage" | translate }}
          </th>
          <td mat-cell class="col-norwap" *matCellDef="let element" >
            {{ element.Triage }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Status">
          <th mat-header-cell *matHeaderCellDef class="custom-header">
            {{ "EncounterListPage.status" | translate }}
          </th>
          <!-- <td
          mat-cell
          [style.font-size.px]="25"
          class="backgroundColor"
          *matCellDef="let element"
          [ngStyle]="{ 'background-color': element.Status.backgroundColor} " 
        >
         <b style="font-size: 11px;">{{ element.Status.text }}</b> 
      </td> -->
      <td mat-cell *matCellDef="let element">
        <span
          class="status-box"
          [ngStyle]="{ 'background-color': element.Status.backgroundColor }"
        >
          {{ element.Status.text }}
        </span>
      </td>
        </ng-container>

        <ng-container matColumnDef="Actions">
          <th mat-header-cell *matHeaderCellDef class="custom-header">
            {{ "EncounterListPage.action" | translate }}
          </th>
          <td mat-cell class="col-norwap" *matCellDef="let element">
            {{ element.Actions }}
          </td>
        </ng-container>
        <ng-container matColumnDef="checkout">
          <th mat-header-cell *matHeaderCellDef class="custom-header">
           {{"EncounterPage.ActionStatus" | translate}}
          </th>
          <td mat-cell class="col-norwap" *matCellDef="let element">
            <div class="image-container">
              <!-- Checkout Button with Image -->
              <button (click)="confirmCheckout(element)" matTooltip="Checkout" style="border: none; background-color: transparent; padding: 0;">
                <img 
                src="{{element.BusinessStatus ? (element.BusinessStatus === 'CHECKOUT' ? './assets/images/encounter/logout.png' : './assets/images/encounter/logout-checkout.png') : './assets/images/encounter/logout-checkout.png'}}"
                class="action-img" />
              </button>
        
              <!-- Billing Status Image -->
              <img 
              class="img action-img"
              [style.width]="'18px'"
              matTooltip="Billing Status"
              src="{{element.statusValue ? (element.statusValue.isBilled ? './assets/images/encounter/bill.png' : './assets/images/encounter/non-bill.png') : './assets/images/encounter/non-bill.png'}}"
              alt="status image" />
        
              <!-- Consultation Status Image -->
              <img
              class="img action-img"
              [style.width]="'20px'"
              matTooltip="Consultation Status"
              src="{{element.statusValue ? (element.statusValue.isConsulted ? './assets/images/encounter/medical-report-p.png' : './assets/images/encounter/medical-report-n.png') : './assets/images/encounter/medical-report-n.png'}}"
              alt="status image" />
        
              <!-- Medication Status Image -->
              <img
              class="img action-img"
              [style.width]="'20px'"
              matTooltip="Medication Status"
              src="{{ getMedicationImage(element) }}"
              alt="status image" />

              <!-- redirect to billing -->
                <mat-icon
                matTooltip="{{ 'adt.receipt' | translate }}"
                data-automation-attribute="icon-receipt"
                (click)="viewBill(element.MRN)"
                >receipt</mat-icon>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; let i = index; columns: displayedColumns"
          (click)="getEncounter(i, row)"
          class="mat-row {{ selectedRow == i ? 'row-hightlighted' : '' }}"
        ></tr>
      </table>

      <div class="center" *ngIf="dataSource.data.length == 0">
        {{ "EncounterListPage.noEncounter" | translate }}
      </div>
    </div>
  </mat-drawer-content>
  <mat-drawer  position="end"
  #drawer
  mode="over"  style="height: 75vh;">
  <div style="height: 75vh; overflow: auto">
    <div class="timeline">
      <div class="outer">
        <div *ngFor="let history of internalList">
          <div class="card">
            <div class="info">
              <div style="display: block; font-size: 12px">
                <span class="title">{{ history.status }}</span
                ><br />
                <div
                  style="float: left; text-align: initial; margin-top: 4px"
                >
                &nbsp;&nbsp;Performed by <span style="font-size: 12px; font-weight: bold;" >{{ history.createdBy }}</span
                  > on<br />&nbsp;
                  <span>
                    {{ history.createdOn }}</span
                  >
                  <br>
                  <div *ngIf="history.status === 'CANCELLED'">
                    &nbsp;&nbsp;<b>Reason: </b> <span>{{ history.reason}}</span> <br>
                    &nbsp;&nbsp;<b>Remark: </b> <span>{{ history.remark}}</span> 
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="center" *ngIf="internalList.length == 0">
          Not Found Data
        </div>
      </div>
    </div>
  </div>
</mat-drawer>
</mat-drawer-container>
  <div class="divFullWidth" data-automation-attribute="divFooterAction">
    <mat-grid-list cols="15" rowHeight="60px" class="divFooterDetails" style="margin-right: -4.5%;">
      <mat-grid-tile [colspan]="13"  class="button-right">
        <div class="mat-grid-tile-content">
         
          <button
          class="action-btn"
          mat-button
          data-automation-attribute="btn"
          (click)="printReport(selectedEncounter, 'encounterDefaultDepositSlip')"
        >
          <img
          class="img action-img"
            [style.width]="'25px'"
            matTooltip="Default Deposit"
            class="img"
            [src]="'./assets/images/adt-icons/Admission-Form.png'"
          /></button
        >&nbsp;&nbsp;&nbsp;
          <button
          class="action-btn"
          mat-button
          data-automation-attribute="btn"
          (click)="printReport(selectedEncounter, 'encounterSlip')"
        >
          <img
          class="img action-img"
            [style.width]="'25px'"
            matTooltip="{{ 'adt.EncounterSlip' | translate }}"
            class="img"
            [src]="'./assets/images/adt-icons/Patient_Consent.png'"
          /></button
        >&nbsp;&nbsp;&nbsp;

        <button
          class="action-btn"
          mat-button
          data-automation-attribute="btn"
          (click)="printReport(selectedEncounter, 'patientLabel')"
        >
          <img
          class="img action-img"
            [style.width]="'25px'"
            matTooltip="{{ 'adt.PatientLabel' | translate }}"
            class="img"
            [src]="'./assets/images/adt-icons/Admission-Lebel.png'"
          /></button
        >&nbsp;&nbsp;&nbsp;

        <button
          class="action-btn"
          mat-button
          data-automation-attribute="btn"
          (click)="printReport(selectedEncounter, 'pdpaFormnew')"
        >
          <img
          class="img action-img"
            [style.width]="'25px'"
            matTooltip="{{ 'adt.PDPAForm' | translate }}"
            class="img"
            [src]="'./assets/images/adt-icons/Admission-Form.png'"
          /></button
        >&nbsp;&nbsp;&nbsp;

          <button
          class="action-btn"
          mat-button
          data-automation-attribute="btn"
          (click)="getGuaranteeLetterDetails()"
        >
          <img
          class="img action-img"
            [style.width]="'25px'"
            matTooltip="{{ 'adt.guaranteeLetter' | translate }}"
            class="img"
            [src]="'./assets/images/adt-icons/patient_guarantee_letter.png'"
          /></button
        >&nbsp;&nbsp;&nbsp;

        <button
        class="action-btn"
        mat-button
        data-automation-attribute="btn"
        (click)="uploadDocument()"
      >
        <img
        class="img action-img"
          [style.width]="'25px'"
          matTooltip="{{ 'adt.uploadDocument' | translate }}"
          class="img"
          [src]="'./assets/images/adt-icons/Upload_Document.png'"
        /></button
      >&nbsp;&nbsp;&nbsp;

          <button
          class="action-btn"
            mat-button
            data-automation-attribute="btn"
            (click)="addInternalNotes()"
          >
            <img
            class="img action-img"
              [style.width]="'25px'"
              matTooltip="{{ 'adt.addInternalNotes' | translate }}"
              class="img"
              [src]="'./assets/images/adt-icons/Admission_Notes.png'"
            /></button
          >&nbsp;&nbsp;&nbsp;

          <button
          class="action-btn"
            mat-button
            data-automation-attribute="btn"
            (click)="getKinDetails()"
          >
            <img
            class="img action-img"
              [style.width]="'25px'"
              matTooltip="{{ 'adt.kinDetails' | translate }}"
              class="img"
              [src]="'./assets/images/adt-icons/Next-of_Kin.png'"
            /></button
          >&nbsp;&nbsp;&nbsp;

          <button
          class="action-btn"
            mat-button
            data-automation-attribute="button-cancel-dialog"
            *ngIf="isCancelSplRight"
            type="submit"
            style="border-color: red"
            (click)="cancelEncounter()"
          >
            <img
            class="img action-img"
              [style.width]="'25px'"
              matTooltip="{{ 'adt.CancelVisit' | translate }}"
              class="img"
              [src]="'./assets/images/adt-icons/Cancel-Admission.png'"
            /></button
          >&nbsp;&nbsp;&nbsp;
          
          <button
          class="action-btn"
            mat-button
            data-automation-attribute="btn"
            (click)="getAccountDetails()"
          >
            <img
            class="img action-img"
              [style.width]="'25px'"
              matTooltip="{{ 'adt.accountDetails' | translate }}"
              class="img"
              [src]="'./assets/images/adt-icons/patient_payer_details.png'"
            /></button
          >&nbsp;&nbsp;&nbsp;

          <button
          class="action-btn"
            mat-button
            data-automation-attribute="btn"
            (click)="getDepositDetails()"
          >
            <img
            class="img action-img"
              [style.width]="'25px'"
              matTooltip="{{ 'billing.deposit' | translate }}"
              class="img"
              [src]="'./assets/images/adt-icons/Patient-Deposit.png'"
            /></button
          >&nbsp;&nbsp;&nbsp;

          <button
          class="action-btn" 
          mat-button 
          data-automation-attribute="btn"
          (click)="openChangeProvider(selectedEncounter)"
          >
            <img
            class="img action-img"
              [style.width]="'25px'"
              matTooltip="{{ 'adt.changeProvider' | translate }}"
              class="img"
              [src]="'./assets/images/adt-icons/Change_Primary_Care.png'"
            />
          </button>&nbsp;&nbsp;&nbsp;
          <button
            class="action-btn"
            mat-button
            data-automation-attribute="btn"
            (click)="patientJourney()"
            matTooltip="History"
          ><mat-icon class="custom-icon">history</mat-icon>
            </button
          >
          </div>
        </mat-grid-tile>
    </mat-grid-list>
  </div>
  <div>
    <!-- <mat-grid-list cols="12" rowHeight="70px">
      <mat-grid-tile [colspan]="1" >
        <mat-icon  style="margin-right: 65px;"
          class="cyanFont green"
          (click)="refreshSearch()"
          matTooltip="{{ 'adt.refresh' | translate }}"
          data-automation-attribute="icon-cancel"
          >refresh</mat-icon
        >
      </mat-grid-tile>
      <mat-grid-tile [colspan]="3"></mat-grid-tile>
      <mat-grid-tile [colspan]="4"></mat-grid-tile>
      <mat-grid-tile [colspan]="4">
        <mat-paginator
          [length]="totalDataLength"
          [pageSize]="pageSize"
          (page)="getNext($event)"
          #paginator
          [pageSizeOptions]="paginatorOptions"
        >
        </mat-paginator>
      </mat-grid-tile>
    </mat-grid-list> -->
  </div>
  <!-- <mat-drawer
    (closedStart)="onClose()"
    position="end"
    #drawerEncounter
    mode="over"
  >
    <div class="encounter-drawer-content">
      <div class="mt-10">
        <table class="table-drawer-encounter">
          <tbody>
            <tr>
              <td class="center" rowspan="4" style="background-color: white">
                <img
                  class="encounter-img"
                  [src]="selectedEncounter?.PatientPhoto"
                />
              </td>
            </tr>
            <tr>
              <td>
                <b>{{ selectedEncounter?.PatientName }}</b
                >&nbsp;&nbsp;
                <img
                  class="user-img"
                  [src]="
                    isVip ? '../assets/images/email-icons/vip-icon.png' : null
                  "
                  *ngIf="isVip"
                  [style.height.px]="25"
                />
              </td>
            </tr>
            <tr>
              <td>{{ selectedEncounter?.MRN }}</td>
            </tr>
            <tr>
              <td>
                {{ selectedEncounter?.PatientGender }} /
                {{ selectedEncounter?.PatientAge }}
              </td>
            </tr>
            <tr>
              <td>
                <mat-icon class="icon-drawer">insert_invitation</mat-icon>
                {{ "EncounterListPage.idDocNo" | translate }}
              </td>
              <td>
                {{ selectedEncounter?.IdentificationType }} /
                {{ selectedEncounter?.IdentificationNo }}
              </td>
            </tr>
            <tr>
              <td>
                <mat-icon class="icon-drawer">insert_invitation</mat-icon>
                {{ "EncounterListPage.visitType" | translate }}
              </td>
              <td>Out Patient</td>
            </tr>

            <tr>
              <td>
                <mat-icon class="icon-drawer">insert_invitation</mat-icon>
                {{ "EncounterPage.referralType" | translate }}
              </td>
              <td>{{ selectedEncounter?.referralType }}</td>
            </tr>
            <tr>
              <td>
                <mat-icon class="icon-drawer">video_label</mat-icon>
                {{ "EncounterListPage.department" | translate }}
              </td>
              <td>{{ selectedEncounter?.DepartmentName }}</td>
            </tr>
            <tr>
              <td>
                <mat-icon class="icon-drawer">supervised_user_circle</mat-icon>
                {{ "EncounterListPage.doctor" | translate }}
              </td>
              <td>{{ selectedEncounter?.DoctorName }}</td>
            </tr>
            <tr>
              <td>
                <mat-icon class="icon-drawer">calendar_today</mat-icon>
                {{ "EncounterListPage.encounterDate" | translate }}
              </td>
              <td>
                {{ selectedEncounter?.VisitDate | date: "dd/MM/yyyy hh:mm aa" }}
              </td>
            </tr>
            <tr>
              <td>
                <mat-icon class="icon-drawer">query_builder</mat-icon>
                {{ "EncounterListPage.appointmentDate" | translate }}
              </td>
              <td>
                {{ selectedEncounter?.AppointmentDate }}
              </td>
            </tr>
            <tr>
              <td>
                <mat-icon class="icon-drawer">navigation</mat-icon>
                {{ "EncounterListPage.address" | translate }}
              </td>
              <td>
                <div style="width: 460px; word-wrap: break-word">
                  {{ selectedEncounter?.Address }}
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <mat-icon class="icon-drawer">streetview</mat-icon>
                {{ "EncounterListPage.email" | translate }}
              </td>
              <td>{{ selectedEncounter?.PatientEmailId }}</td>
            </tr>
            <tr>
              <td>
                <mat-icon class="icon-drawer">personal_video</mat-icon>
                {{ "EncounterListPage.phone" | translate }}
              </td>
              <td>{{ selectedEncounter?.PatientMobileno }}</td>
            </tr>
            <tr>
              <td>
                <mat-icon class="icon-drawer">room_service</mat-icon>
                {{ "EncounterListPage.clinic" | translate }}
              </td>
              <td>{{ selectedEncounter?.Clinic }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="center mt-20">
        <button
          *ngIf="isCancelSplRight && selectedEncounter?.Status != 'CANCELLED'"
          (click)="cancelEncounter()"
          class="btn-enc-action"
        >
          {{ "EncounterListPage.cancelvisit" | translate }}
        </button>

        <button class="btn-enc-action" (click)="addInternalNotes()">
          {{ "EncounterListPage.interNotes" | translate }}
        </button>
        <button class="btn-enc-action" (click)="uploadDocument()">
          {{ "EncounterListPage.upload" | translate }}
        </button>
        <button class="btn-enc-action" (click)="patientJourney()">
          Patient Journey
        </button>
      </div>
    </div>
  </mat-drawer> -->
 
<div class="footer-container">
  <app-footer
  [showFooter]="true"
  [totalDataLength]="totalDataLength"
  [pageSize]="pageSize"
  [pageIndex]="pageIndex"
  [paginatorOptions]="paginatorOptions"
  (pageChange)="getNext($event)"
  (refresh)="refreshSearch()">
  </app-footer>
  </div>